module.exports = __webpack_public_path__ + "static/img/b_3.0ba903e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b_3.jpg
// module id = 252
// module chunks = 0 1 2 3 4 5 6 7 8 9